module.exports = __webpack_public_path__ + "static/media/regus-icon-font.e84c29a4.woff";